<template>
    <div ref="modaldes" class="modal" tabindex="-1" role="dialog" id="modal-ncobrador">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <!-- <div class="modal-header">
                    <h5 class="modal-title text-center"><b>Asignar Encargada de Cobranzas</b></h5>
                </div> -->

                <div class="modal-body">
                    <p class="text-center mb-1 mt-4">
                        <b>Se asignará un responsable de cobranza al siguiente estudiante:</b>
                    </p>
                    <p class="mb-0 mt-0 text-center">{{ ins.estudiante.nombres }} {{ ins.estudiante.pri_apellido }} {{ ins.estudiante.seg_apellido }}</p>

                    <div class="xcard">
                        <p class="mb-0 mt-5"><span class="text-danger">*</span> Seleccione al responsable para la cobranza:</p>
                        <div>
                            <v-combobox v-model="input.responsable" :items="responsables" label="Responsable de cobranza" :loading="loadingusuarios" :disabled="loading" hide-details outlined dense></v-combobox>
                        </div>

                        <XFechas ref="xfechas" />
                    </div>

                    <p class="text-center text-danger">
                        <b>{{ msg }}</b>
                    </p>
                    <div class="text-center">
                        <div style="display: inline-block;" v-show="loading" class="loader"></div>
                    </div>
                </div>

                <div class="modal-footer">
                    <button @click="validar()" :disabled="loading || exitoso" type="button" class="btn btn-azul white--text">Asignar al estudiante</button>
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import XFechas from "@/components/AAsignarCobradorFechas.vue";
export default {
    data() {
        return {
            msg: "",
            loading: false,
            exitoso: false,
            loadingusuarios: false,
            responsables: [],
            input: {
                responsable: null,
            },
            ins: { estudiante: {} },
        };
    },
    watch: {},
    components: { XFechas },
    computed: {
        computedDateFormatted() {
            return this.formatDate(this.date);
        },
    },
    methods: {
        open(ins) {
            //window.console.log("asignar cobrador", ins, prog);
            this.ins.estudiante = ins.estudiante;
            this.ins.id = ins.id;
            this.exitoso = false;
            this.input.responsable = null;
            this.msg = "";
            this.$refs.xfechas.load();
            window.$("#modal-ncobrador").modal("show");
        },
        validar() {
            this.msg = "";
            this.loading = false;
            let inicio = this.$refs.xfechas.getfechainicio();
            let fin = this.$refs.xfechas.getfechafin();
            window.console.log(inicio, fin);
            if (!this.input.responsable) {
                this.msg = "Seleccione a un responsable";
                return;
            }
            if (!inicio) {
                this.msg = "Seleccione la fecha de inicio";
                return;
            }
            if (!fin) {
                this.msg = "Seleccione la fecha de finalizacion";
                return;
            }
            this.enviardatos(inicio, fin);
        },
        enviardatos(inicio, fin) {
            const vue = this;
            this.loading = true;
            let url = `${process.env.VUE_APP_API_REST}/api/v1/asignacion/inscrito`;
            let data = {
                fecha_fin: fin,
                fecha_inicio: inicio,
                inscripcion_id: this.ins.id,
                usuario_id: 1,
            };
            window.console.log(data);

            axios
                .post(url, data)
                .then((data) => {
                    window.console.log(data);
                    vue.loading = false;
                })
                .catch((error) => {
                    window.console.error(error);
                    vue.loading = false;
                });
        },
    },
    mounted() {},
};
</script>
